import React from 'react';

import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useNavigate} from 'react-router-dom';

import {useTenantInfo} from 'modules/tenant/hooks';
import {formatAxiosErrorOrThrow} from 'shared/utils/error';
import {ICreateUserForm} from 'users/pages/CreateUser/CreateUser';
import {createUserFromPublicSignupPage} from 'modules/user/api/user';
import { useSignupPageIdFromUrl } from 'modules/signup-page/hooks/useSignupPageIdFromUrl';

import {FullScreenModal} from 'shared/components/FullScreenModal/FullScreenModal';
import {FullScreenModalTitle} from 'shared/components/FullScreenModal/FullScreenModalTitle';
import { PublicSignupParentForm } from 'shared/pages/Signup/PublicSignup/PublicSignupParent/PublicSignupParentForm';

export const PublicSignupParent = () => {
    const {t} = useTranslation();
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

    const {tenantInfo} = useTenantInfo();
    const signupPageId = useSignupPageIdFromUrl();

    console.log('signupPageId', signupPageId);

    const navigate = useNavigate();

    const onSubmit = ({role, ...userCreate}: ICreateUserForm) => {
        if (isSubmitting || !signupPageId) {
            return;
        }
        setIsSubmitting(true);
        (async () => {
            try {
                await createUserFromPublicSignupPage(
                    tenantInfo.id,
                    signupPageId,
                    {
                        roles: [role],
                        ...userCreate,
                    },
                );
                // redirect to login page
                navigate('/login');
                toast.success(t('signup.success', 'Signup successful! Please login'));
            } catch (e) {
                toast.error(formatAxiosErrorOrThrow(
                    t('signup.error', 'Signup was unsuccessful. Please try again.'),
                    e,
                ));
            } finally {
                setIsSubmitting(false);
            }
        })();
    };

    return (
        <FullScreenModal close={false} size="md">
            <FullScreenModalTitle className="mb-4">
                {t(
                    'common.parentSignup.title', 'Sign up as a Parent to Young Eyes',
                )}
            </FullScreenModalTitle>
            <PublicSignupParentForm isSubmitting={isSubmitting} onSubmit={onSubmit}/>
        </FullScreenModal>
    );
};